import { createSelector } from 'reselect';

import { STAKEHOLDER_ROLES_V2 } from '@/containers/withStakeholderLogic';
import { getRecollectionData, getStakeholders } from '@/selectors/merchant/recollection';

export const hasUltimateBeneficialOwner = createSelector(
  getStakeholders,
  stakeholders =>
    !!stakeholders.find(({ roles = [] }) =>
      roles.includes(STAKEHOLDER_ROLES_V2.ULTIMATE_BENEFICIAL_OWNER),
    ),
);

export const hasControlOverManagement = createSelector(
  getStakeholders,
  stakeholders =>
    !!stakeholders.find(({ roles = [] }) =>
      roles.includes(STAKEHOLDER_ROLES_V2.CONTROL_OVER_MANAGEMENT),
    ),
);

export const hasApplicant = createSelector(
  getStakeholders,
  stakeholders =>
    !!stakeholders.find(({ roles = [] }) => roles.includes(STAKEHOLDER_ROLES_V2.APPLICANT)),
);

export const canShowSummaryRecollection = createSelector(
  hasUltimateBeneficialOwner,
  hasControlOverManagement,
  hasApplicant,
  (hasUBO, hasCOM, hasApplicant) => (hasUBO || hasCOM) && hasApplicant,
);

export const isSubmitted = createSelector(getRecollectionData, ({ isSubmitted }) => isSubmitted);
